import { AxiosRequestConfig } from 'axios';

const endpoint = '/api/contract-transactions';

export default {
    update: (id: string, data: any) => ({ method: 'PUT', url: `${endpoint}/${id}`, data } as AxiosRequestConfig),
};
